(() => {
  if (window.AlphaEditorial || new URLSearchParams(location.search).get('alpha_editorial_preview') === '1') return;
  const node = document.getElementById('AlphaEditorialContext');
  if (!node) return;
  let context;
  try { context = JSON.parse(node.textContent); } catch { return; }
  if (context.shop !== 'tableaudecoration.myshopify.com') return;
  const key = 'alpha_editorial_last_article_v1', viewedPrefix = 'alpha_editorial_viewed_', maxAge = 7 * 86400000;
  const viewedInPage = new Set();
  const idValid = id => typeof id === 'string' && /^[1-9]\d{5,24}$/.test(id);
  const privacy = () => window.Shopify?.customerPrivacy;
  const analyticsAllowed = () => { try { return privacy()?.analyticsProcessingAllowed() === true; } catch { return false; } };
  const attributionAllowed = () => { try { return analyticsAllowed() && privacy()?.marketingAllowed() === true; } catch { return false; } };
  const remove = () => { try { localStorage.removeItem(key); } catch {} };
  const stored = () => {
    if (!attributionAllowed()) return null;
    try {
      const a = JSON.parse(localStorage.getItem(key) || 'null');
      if (!a || !idValid(a.article_id) || !Number.isSafeInteger(a.touched_at) || a.touched_at > Date.now() + 60000 || Date.now() - a.touched_at > maxAge) { remove(); return null; }
      return a;
    } catch { return null; }
  };
  const getAttribution = () => { const a = stored(); return a ? { article_id:a.article_id, touched_at:a.touched_at, consent:true } : null; };
  const articleId = () => idValid(context.article_id) ? context.article_id : getAttribution()?.article_id;
  const emit = (event, product = '') => {
    const article_id = articleId();
    if (!analyticsAllowed() || !article_id || !crypto.randomUUID) return;
    try {
      fetch('/apps/alpha-reproduction-pod?mode=editorial', { method:'POST', credentials:'same-origin', keepalive:true, headers:{'Content-Type':'application/json'}, body:JSON.stringify({event,event_id:crypto.randomUUID(),article_id,product,consent:true}) }).catch(() => {});
    } catch {}
  };
  const initialize = () => {
    if (!privacy()) return;
    if (!analyticsAllowed()) {
      remove();
      try { for (const k of Object.keys(sessionStorage)) if (k.startsWith(viewedPrefix)) sessionStorage.removeItem(k); } catch {}
      document.querySelectorAll('[data-alpha-editorial-field]').forEach(n => n.remove());
      return;
    }
    if (!attributionAllowed()) remove();
    if (idValid(context.article_id)) {
      if (attributionAllowed()) {
        const path = typeof context.article_path === 'string' && context.article_path.startsWith('/blogs/') && !/[?#]/.test(context.article_path) ? context.article_path : '';
        try { localStorage.setItem(key, JSON.stringify({article_id:context.article_id,touched_at:Date.now(),path})); } catch {}
      }
      let seen = viewedInPage.has(context.article_id);
      try { seen = seen || sessionStorage.getItem(viewedPrefix + context.article_id) === '1'; } catch {}
      if (!seen) { viewedInPage.add(context.article_id); emit('article_view'); try { sessionStorage.setItem(viewedPrefix + context.article_id,'1'); } catch {} }
    }
  };
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || !analyticsAllowed()) return;
    const a = e.target.closest?.('a[href]');
    if (a) {
      let u; try { u = new URL(a.href,location.href); } catch { return; }
      if (u.origin === location.origin && /\/products\/[^/]+\/?$/.test(u.pathname)) {
        const raw = u.pathname.split('/').filter(Boolean).at(-1);
        try { emit('product_click',decodeURIComponent(raw)); } catch {}
      }
      if (u.origin === location.origin && /\/pages\/(contact|reproduction-tableau-sur-mesure)\/?$/.test(u.pathname) || u.hostname === 'wa.me' && e.target.closest('[data-oil-quote-whatsapp]')) emit('quote_contact_click',context.product_handle || '');
    } else if (e.target.closest?.('[data-oil-quote-email],[data-oil-quote-whatsapp]')) emit('quote_contact_click',context.product_handle || '');
  });
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented || !form.checkValidity() || form.querySelector('[name="form_type"]')?.value !== 'contact') return;
    const a = stored();
    if (a) {
      let field = form.querySelector('[data-alpha-editorial-field]');
      if (!field) { field = document.createElement('input'); field.type='hidden'; field.name='contact[Article source]'; field.dataset.alphaEditorialField=''; form.append(field); }
      field.value = a.path ? location.origin + a.path : 'Article ' + a.article_id;
      emit('quote_submit',context.product_handle || '');
    }
  });
  document.addEventListener('formdata', e => {
    const form=e.target,a=getAttribution();
    if (!(form instanceof HTMLFormElement) || !a) return;
    let url; try { url=new URL(form.action,location.href); } catch { return; }
    if (url.origin !== location.origin || !/\/cart\/add\/?$/.test(url.pathname)) return;
    e.formData.set('properties[_Alpha editorial article]',a.article_id);
    e.formData.set('properties[_Alpha editorial touched]',String(a.touched_at));
    e.formData.set('properties[_Alpha editorial method]','last-blog-7d-v1');
  });
  document.addEventListener('visitorConsentCollected',initialize);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded',initialize);
  window.addEventListener('pageshow',initialize);
  window.AlphaEditorial={getAttribution};
  initialize();
  let attempts=0;const waitForPrivacy=()=>{if(privacy()){initialize();return;}if(++attempts<10)setTimeout(waitForPrivacy,1000);};waitForPrivacy();
})();
